import { Component, OnInit } from '@angular/core';
import { Group } from '@microsoft/microsoft-graph-types-beta';
import { map, Observable, skipUntil } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { BaseComponent } from '../../../base/base.component';
import { initAuthenticationMethodsFido2Form } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/fido2/form';
import { updateAuthenticationMethodsFido2Schema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/fido2/schema';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { Fido2AuthenticationMethodConfigurationForm } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/fido2/model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    groups$: Observable<Map<string, Group>>;
    constructor(private store: Store<any>) {
        super();
    }
    ngOnInit(): void {
        this.groups$ = this.store
            .pipe(select(client(this.tenant_id).graph.groups.all))
            .pipe(skipUntil(this.store.pipe(select(client(this.tenant_id).graph.groups.loaded))))
            .pipe(
                map((groups) => {
                    return new Map(groups.map((group) => [group.id, group]));
                }),
            );

        const schema = JSON.parse(JSON.stringify(this.baseline.schema));
        this.form = initAuthenticationMethodsFido2Form(schema);

        this.form.valueChanges.subscribe((_) => {
            const form = this.formValue;
            const updatedSchema = updateAuthenticationMethodsFido2Schema(form);

            if (this.form.invalid) {
                this.baselineErrorChange.next({ remediate: true, save: true });
            } else {
                this.baselineErrorChange.next({ remediate: false, save: false });
            }

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(updatedSchema)),
            });
        });
    }

    get formValue(): Fido2AuthenticationMethodConfigurationForm {
        return this.form.getRawValue();
    }
}
